import type { ItemDefInput } from '../../schemas/items';
import { HERITAGE_DECOR } from './heritage';
import { STUDIO_DECOR } from './studio';

/** Decor (docs/design/content-items.md §C): rugs, surface pieces, wall pieces and potted plants. */
export const DECOR = [
  {
    id: 'dec_strawberry_rug',
    kind: 'decor',
    nameKey: 'item.dec_strawberry_rug.name',
    loreKey: 'item.dec_strawberry_rug.lore',
    shopTab: 'decor',
    layer: 'floor',
    footprint: { w: 2, h: 2 },
    rotations: 1,
    tags: ['rug'],
    homeTags: ['zone:center'],
    themeTags: ['cute', 'sweet'],
    setId: 'set_strawberry',
    unlockId: 'unl_home',
    buyPrice: 90,
    material: 'fabric',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_dec_strawberry_rug' },
  },
  {
    id: 'dec_heart_cushion',
    kind: 'decor',
    nameKey: 'item.dec_heart_cushion.name',
    loreKey: 'item.dec_heart_cushion.lore',
    shopTab: 'decor',
    layer: 'surface',
    rotations: 1,
    tags: ['cushion'],
    homeTags: ['on:sofa'],
    themeTags: ['cute'],
    setId: 'set_strawberry',
    unlockId: 'unl_catalog_t2',
    buyPrice: 35,
    material: 'fabric',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_dec_heart_cushion' },
  },
  {
    id: 'dec_strawberry_clock',
    kind: 'decor',
    nameKey: 'item.dec_strawberry_clock.name',
    loreKey: 'item.dec_strawberry_clock.lore',
    shopTab: 'decor',
    layer: 'wall',
    wallSpan: 1,
    rotations: 2,
    tags: ['clock'],
    homeTags: ['wall'],
    themeTags: ['cute', 'sweet'],
    setId: 'set_strawberry',
    unlockId: 'unl_catalog_t2',
    buyPrice: 55,
    material: 'ceramic',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_dec_strawberry_clock' },
  },
  {
    id: 'dec_cat_nightlight',
    kind: 'decor',
    nameKey: 'item.dec_cat_nightlight.name',
    loreKey: 'item.dec_cat_nightlight.lore',
    shopTab: 'decor',
    layer: 'surface',
    rotations: 2,
    tags: ['lamp', 'light', 'cat'],
    homeTags: ['on:nightstand'],
    themeTags: ['cute', 'pet'],
    unlockId: 'unl_home',
    buyPrice: 60,
    material: 'ceramic',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_dec_cat_nightlight' },
  },
  {
    id: 'dec_desk_lamp',
    kind: 'decor',
    nameKey: 'item.dec_desk_lamp.name',
    loreKey: 'item.dec_desk_lamp.lore',
    shopTab: 'decor',
    layer: 'surface',
    rotations: 2,
    tags: ['lamp', 'light'],
    homeTags: ['on:desk'],
    themeTags: ['office'],
    setId: 'set_office',
    unlockId: 'unl_home',
    buyPrice: 50,
    material: 'metal',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_dec_desk_lamp' },
  },
  {
    id: 'dec_cork_board',
    kind: 'decor',
    nameKey: 'item.dec_cork_board.name',
    loreKey: 'item.dec_cork_board.lore',
    shopTab: 'decor',
    layer: 'wall',
    wallSpan: 1,
    rotations: 2,
    tags: ['board'],
    homeTags: ['wall + near:desk'],
    themeTags: ['office'],
    setId: 'set_office',
    unlockId: 'unl_catalog_t2',
    buyPrice: 45,
    material: 'wood',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_dec_cork_board' },
  },
  {
    id: 'dec_coffee_machine',
    kind: 'decor',
    nameKey: 'item.dec_coffee_machine.name',
    loreKey: 'item.dec_coffee_machine.lore',
    shopTab: 'decor',
    layer: 'surface',
    rotations: 2,
    tags: ['appliance', 'coffee'],
    homeTags: ['on:kitchen_counter'],
    themeTags: ['office'],
    setId: 'set_office',
    unlockId: 'unl_catalog_t2',
    buyPrice: 120,
    material: 'metal',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_dec_coffee_machine' },
  },
  {
    // First clear of Bếp của bà level 1 (minigames.md §4.11); not in the catalog. No "đúng chỗ" on purpose:
    // a free right-spot decor this early pulls Home Coziness Lv3 (+7⭐) ten sessions forward (sim:progression).
    id: 'dec_jam_jars',
    kind: 'decor',
    nameKey: 'item.dec_jam_jars.name',
    loreKey: 'item.dec_jam_jars.lore',
    shopTab: 'decor',
    layer: 'surface',
    rotations: 1,
    tags: ['jam', 'homemade'],
    themeTags: ['sweet', 'cozy'],
    material: 'glass',
    sources: [{ kind: 'reward', ref: 'mg_cooking_l1' }],
    sprite: { frame: 'item_dec_jam_jars' },
  },
  {
    id: 'dec_monstera',
    kind: 'decor',
    nameKey: 'item.dec_monstera.name',
    loreKey: 'item.dec_monstera.lore',
    shopTab: 'plants',
    layer: 'object',
    footprint: { w: 1, h: 1 },
    rotations: 2,
    tags: ['plant'],
    homeTags: ['zone:window'],
    themeTags: ['garden', 'healthy'],
    setId: 'set_garden',
    unlockId: 'unl_home',
    buyPrice: 75,
    material: 'plant',
    sources: [{ kind: 'catalog' }, { kind: 'gift', npcId: 'npc_lan', level: 1 }],
    sprite: { frame: 'item_dec_monstera' },
  },
  {
    id: 'dec_hanging_pothos',
    kind: 'decor',
    nameKey: 'item.dec_hanging_pothos.name',
    loreKey: 'item.dec_hanging_pothos.lore',
    shopTab: 'plants',
    layer: 'wall',
    wallSpan: 1,
    rotations: 2,
    tags: ['plant'],
    homeTags: ['wall + zone:window'],
    themeTags: ['garden'],
    setId: 'set_garden',
    unlockId: 'unl_catalog_t2',
    buyPrice: 50,
    material: 'plant',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_dec_hanging_pothos' },
  },
  {
    id: 'dec_herb_pots',
    kind: 'decor',
    nameKey: 'item.dec_herb_pots.name',
    loreKey: 'item.dec_herb_pots.lore',
    shopTab: 'plants',
    layer: 'surface',
    rotations: 2,
    tags: ['plant', 'herb'],
    homeTags: ['on:kitchen_counter'],
    themeTags: ['garden', 'healthy'],
    setId: 'set_garden',
    unlockId: 'unl_home',
    buyPrice: 40,
    material: 'plant',
    sources: [{ kind: 'starter', boxId: 'box_05_granny' }, { kind: 'catalog' }],
    sprite: { frame: 'item_dec_herb_pots' },
  },
  {
    id: 'dec_book_stack',
    kind: 'decor',
    nameKey: 'item.dec_book_stack.name',
    loreKey: 'item.dec_book_stack.lore',
    shopTab: 'decor',
    layer: 'surface',
    rotations: 2,
    tags: ['book'],
    homeTags: ['on:bookshelf'],
    themeTags: ['cozy'],
    unlockId: 'unl_home',
    buyPrice: 30,
    material: 'paper',
    sources: [
      { kind: 'starter', boxId: 'box_03_books' },
      { kind: 'catalog' },
      { kind: 'reward', ref: 'mg:mg_dusting:L2' },
    ],
    sprite: { frame: 'item_dec_book_stack' },
  },
  {
    id: 'dec_fairy_lights',
    kind: 'decor',
    nameKey: 'item.dec_fairy_lights.name',
    loreKey: 'item.dec_fairy_lights.lore',
    shopTab: 'decor',
    layer: 'wall',
    wallSpan: 2,
    rotations: 2,
    tags: ['light'],
    homeTags: ['wall'],
    themeTags: ['cute', 'cozy'],
    unlockId: 'unl_catalog_t2',
    buyPrice: 65,
    material: 'glass',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_dec_fairy_lights' },
  },
  {
    id: 'dec_mug_deadline',
    kind: 'decor',
    nameKey: 'item.dec_mug_deadline.name',
    loreKey: 'item.dec_mug_deadline.lore',
    shopTab: 'decor',
    layer: 'surface',
    rotations: 2,
    tags: ['mug', 'coffee'],
    homeTags: ['on:desk'],
    themeTags: ['office'],
    setId: 'set_office',
    material: 'ceramic',
    sources: [{ kind: 'gift', npcId: 'npc_bao', level: 2 }],
    sprite: { frame: 'item_dec_mug_deadline' },
  },
  {
    id: 'dec_grandma_camera',
    kind: 'decor',
    nameKey: 'item.dec_grandma_camera.name',
    loreKey: 'item.dec_grandma_camera.lore',
    shopTab: 'decor',
    layer: 'surface',
    rotations: 2,
    tags: ['camera', 'grandma'],
    homeTags: ['on:bookshelf'],
    themeTags: ['cozy'],
    material: 'metal',
    sources: [{ kind: 'story', chapterId: 'ch3' }],
    sprite: { frame: 'item_dec_grandma_camera' },
  },
  {
    id: 'dec_grandma_photo',
    kind: 'decor',
    nameKey: 'item.dec_grandma_photo.name',
    loreKey: 'item.dec_grandma_photo.lore',
    shopTab: 'decor',
    layer: 'surface',
    rotations: 1,
    tags: ['photo', 'grandma'],
    homeTags: ['on:nightstand'],
    themeTags: ['cozy'],
    material: 'paper',
    sources: [{ kind: 'story', chapterId: 'ch4' }],
    sprite: { frame: 'item_dec_grandma_photo' },
  },
  ...HERITAGE_DECOR,
  ...STUDIO_DECOR,
] as const satisfies readonly ItemDefInput[];
